// extracted by mini-css-extract-plugin
export default {"Overlay":"Overlay_Overlay__t-xwu","AbsoluteCenter":"Overlay_AbsoluteCenter__xDBQt","purple":"Overlay_purple__WvXZ1","default":"Overlay_default__JC6xT"};